import React, { useEffect } from 'react'

export interface PublishFocusHandoffProps {
  isPending: boolean
  isPublishDisabled: boolean
  publishRef: React.RefObject<HTMLElement>
  // Wraps the actions menu: its trigger takes focus while Publish is disabled.
  fallbackContainerRef: React.RefObject<HTMLElement>
  onDone: () => void
}

// Every Turn on control unmounts on click, which drops focus to the body.
// Publish is the next step, so it takes focus once it is enabled (it can stay
// disabled for a while: locked row, detail loading or unavailable). Until then
// focus parks on the actions menu trigger. Focus moves only while it is still
// on the body or the trigger, so it never steals focus the merchant has moved.
const PublishFocusHandoff = ({
  isPending,
  isPublishDisabled,
  publishRef,
  fallbackContainerRef,
  onDone,
}: PublishFocusHandoffProps) => {
  useEffect(() => {
    if (!isPending) return
    const container = fallbackContainerRef.current
    const active = document.activeElement
    const isFree =
      !active || active === document.body || !!container?.contains(active)
    if (!isFree) {
      onDone()
      return
    }
    if (!isPublishDisabled) {
      publishRef.current?.focus()
      onDone()
      return
    }
    container?.querySelector<HTMLElement>('button, [role="button"]')?.focus()
  }, [isPending, isPublishDisabled, publishRef, fallbackContainerRef, onDone])

  return null
}

export default PublishFocusHandoff
